module.exports = __webpack_public_path__ + "static/media/Georgia-01.c1c62d3b.svg";